import { css } from "@emotion/react";
import * as React from "react";

interface IProps {
  className?: string;
  onChange: (file: File) => void;
  dataTestId?: string;
  children: React.ReactNode | ((props: { onClick: () => void }) => React.ReactNode);
}

const inputCss = css`
  display: none;
`;

export class FileInput extends React.PureComponent<IProps> {
  private fileInputRef: React.RefObject<HTMLInputElement> = React.createRef();

  private handleFilePick = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const {
      // @ts-expect-error TS(2488): Type 'FileList | null' must have a '[Symbol.iterat... Remove this comment to see the full error message
      files: [file],
    } = event.target;
    const { onChange } = this.props;

    if (file) {
      onChange(file);
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      this.fileInputRef.current.value = null;
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getChildren = () => {
    const { children } = this.props;

    if (typeof children === "function") {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      return children({ onClick: () => this.fileInputRef.current.click() });
    }

    return React.Children.map(children, child =>
      React.cloneElement(child as React.ReactElement, {
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        onClick: () => this.fileInputRef.current.click(),
      })
    );
  };

  render(): JSX.Element {
    const { className, dataTestId } = this.props;

    const childrenWithProps = this.getChildren();

    return (
      <div className={className}>
        <input
          css={inputCss}
          type="file"
          onChange={this.handleFilePick}
          ref={this.fileInputRef}
          data-testid={dataTestId}
        />
        {childrenWithProps}
      </div>
    );
  }
}
